import React, { PropsWithChildren } from 'react'
import classes from './Table.module.scss'

export type HeadProps = PropsWithChildren<object>

const Head = ({ children }: HeadProps) => {
  return <div className={classes.head}>{children}</div>
}

export default Head
